module.exports = __webpack_public_path__ + "images/houd-je-meer-van-fruit-a.360w.jpg";